var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getSvgType},[_c(_vm.iconPath(_vm.dynamicValue),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }